<script setup>
import {onMounted, ref, watch, defineProps, defineEmits} from "vue";
import useSharedData from "@/use/SharedData.js";
import axios from "axios";
import {useProductStore} from "@/stores/Product";

const props = defineProps({
    value: [Number, Array],
    readonly: Boolean,
    disabled: Boolean,
    label: String,
    rules: Array,
    multiple: Boolean,
});

const emit = defineEmits(["input"]);

const {loading, inputColor, backgroundColor} = useSharedData();
const productStore = useProductStore();

const product = ref(null);

function findAll() {
    loading.value = true;
    axios.get(`/products`).then(response => {
        productStore.setProducts(response.data);
    }).finally(() => {
        loading.value = false;
    });
}

function input(value) {
    emit('input', value)
}

watch(() => props.value, () => {
    product.value = props.value;
}, {immediate: true});

onMounted(() => findAll());
</script>

<template>
    <div>
        <v-autocomplete
            v-model="product"
            :items="productStore.products"
            item-value="id"
            item-text="name"
            outlined
            dense
            :label="label"
            :color="inputColor"
            :background-color="backgroundColor"
            :readonly="readonly"
            :disabled="disabled"
            :multiple="multiple"
            :loading="loading"
            :clearable="!readonly"
            @input="input"
            :rules="rules"
            hide-details="auto"
        ></v-autocomplete>

        <input type="hidden">
    </div>
</template>